





















import { Component, Prop, Vue } from "vue-property-decorator";
import { IDynamicColumn } from "@/models/dynamicColumns";

@Component
export default class DynamicColumnCell extends Vue {
  @Prop({ required: false })
  public row!: any;
  @Prop({ required: false })
  public column!: IDynamicColumn;
}
